/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withLocalization } from 'hocs/localization'
import { setScrollElementId } from 'redux-app/modules/pageScroller'
import LoginMeta from './LoginMeta'

export default compose(
  connect(
    null,
    {
      setScrollElementId,
    },
  ),
  withRouter,
  withLocalization('auth.login.form.meta'),
)(LoginMeta)
